import apiConfig from "../../api-config";

export const getIpResults = async (userId) => {
  const token = sessionStorage.getItem("authToken");
  const response = await fetch(
    `${apiConfig.api_base_url}/api/${apiConfig.api_key}/get/${userId}/oci/ipResults`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || data.error || "Unable to load OCI IP results");
  return data;
};

